import { useLocale } from "@i18n/react";
import { useQueryClient } from "@tanstack/react-query";

import { useRequestMutation } from "../../../../request/hooks/useRequestMutation";
import { keyHome } from "../../home/keyHome";
import { keyNextUp } from "../../nextUp/keyNextUp";
import { keyPages } from "../../pages/keyPages";
import { keyCampaignDetails } from "../details/keyCampaignDetails";

export type UseRequestCampaignUsersProps = {
  id: number;
};

export const useRequestCampaignUsers = ({
  id,
}: UseRequestCampaignUsersProps) => {
  const urlBackendPath = `/campaigns/${id}/users`;

  const locale = useLocale();
  const queryClient = useQueryClient();

  const invalidateQueries = () => {
    queryClient.invalidateQueries({
      queryKey: [keyCampaignDetails({ id }), locale],
    });
    queryClient.invalidateQueries({ queryKey: [keyHome(), locale] });
    queryClient.invalidateQueries({ queryKey: [keyNextUp(), locale] });
    queryClient.invalidateQueries({
      queryKey: [keyPages({ page: "campaigns" }), locale],
    });
  };

  return {
    mutationDelete: useRequestMutation({
      mutationFnRequestProps: {
        method: "DELETE",
        urlBackendPath,
      },
      onSuccess: () => invalidateQueries(),
    }),
    mutationPost: useRequestMutation({
      mutationFnRequestProps: {
        urlBackendPath,
      },
      onSuccess: () => invalidateQueries(),
    }),
  };
};
